import React, { useState } from "react"
import { FaUserPlus } from "react-icons/fa"
import { sendEnrolUserProgram } from "../../../requesters/Backend/UserRequester"
import ConfirmActionModal from "./ConfirmActionModal"
import QuickAction from "./QuickAction"
import runUserAction from "./runUserAction"

const CODE_LENGTH = 8

function UpdateEnrolment({ baseUrl, refetch, userDetail: { id, active_program: activeProgram } }) {
  const programCode = activeProgram?.unique_id
  const [uniqueCode, setUniqueCode] = useState("")
  const [showModal, setShowModal] = useState(false)

  const handleToggleModal = () => setShowModal(!showModal)
  const handleUniqueCode = e => setUniqueCode(e.target.value)

  const isSameProgram = programCode?.toLowerCase() === uniqueCode?.toLowerCase()
  const isSubmittable = uniqueCode.length === CODE_LENGTH && !isSameProgram

  const handleEnrolUserProgram = () => {
    if (!isSubmittable) return null

    return runUserAction(sendEnrolUserProgram(baseUrl, { user_id: id, unique_id: uniqueCode }), {
      successMessage: "Enrolled in the program",
      fallbackError: "Could not enrol this user",
      onSuccess: () => {
        setShowModal(false)
        refetch()
      }
    })
  }

  return (
    <>
      <QuickAction icon={FaUserPlus} label="Enrol User in another program" onClick={handleToggleModal} />
      <ConfirmActionModal
        confirmDisabled={!isSubmittable}
        confirmLabel="Submit"
        onConfirm={handleEnrolUserProgram}
        onHide={handleToggleModal}
        show={showModal}
        title="Unique code">
        <p>Please enter the unique program code.</p>
        <div className="form-group">
          <input className="form-control" onChange={handleUniqueCode} placeholder="Code" type="text" />
        </div>
      </ConfirmActionModal>
    </>
  )
}

export default UpdateEnrolment
